export default "__VITE_ASSET__DpkWet$k__"